import { useEffect, useState } from 'react';
import { Code, Flex, Heading, Link, Text } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { updateAppConnected } from '../../../../redux/providerBuilder/mobileClient';
import { getAppConnected } from '../../../../redux/providerBuilder/mobileClient/selectors';
import { updateActiveStep } from '../../../../redux/providerBuilder/stepperDetails';
import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../../components/ui/tooltip';
import { Button } from '../../../../components/ui/button';

interface SessionIdDisplayProps {
  sessionId: string;
  accessToken: string;
  userUid: string;
}

export const SessionIdDisplay = (sessionIdDisplayProps: SessionIdDisplayProps) => {
  const dispatch = useAppDispatch();

  const appConnected = useAppSelector(getAppConnected);
  const { sessionId } = sessionIdDisplayProps;

  const handleNext = () => {
    dispatch(updateActiveStep(1));
  };

  useEffect(() => {
    dispatch(updateAppConnected(false));
  }, [dispatch]);

  useEffect(() => {
    if (appConnected) {
      handleNext();
    }
  }, [appConnected]);

  return (
    <>
      <Flex h="100%" direction="column" justifyContent="flex-start" gap={70}>
        <Flex alignItems="flex-start">
          <Flex direction="column" gap={3} alignItems="center" w="100%">
            <Heading className="xx-large-font " fontWeight="bold">
              Build Providers with Reclaim Protocol
            </Heading>
            <Text textAlign="center" className="regular-font">
              Download the{' '}
              <Link
                target="_blank"
                color="blue.500"
                href="https://play.google.com/store/apps/details?id=com.reclaim.protocol&hl=en_IN&pli=1"
              >
                Reclaim Protocol App
              </Link>{' '}
              and enter below Session ID <br /> to start building providers
            </Text>
            {sessionId && (
              <Flex alignItems="center" gap={2}>
                <Code
                  className="x-large-font"
                  letterSpacing="2px"
                  px={7}
                  py={2}
                  borderRadius={5}
                  colorScheme="cyan"
                >
                  {sessionId}
                </Code>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="p-2 text-muted-foreground hover:text-foreground"
                      >
                        <HelpCircle className="h-[45px] w-[45px]" />
                        <span className="sr-only">Session ID Info</span>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>The Session ID links your mobile and desktop apps <br /> to capture the correct website data.</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </Flex>
            )}
          </Flex>
        </Flex>
        <Flex
          justifyContent="center"
          alignItems="center"
          flex={1}
          borderTop="1.5px solid"
          pt={20}
          borderColor="gray.200"
        >
          <iframe
            className="provider-builder-iframe"
            src="https://www.youtube.com/embed/WXCduLA95jo?si=DAPTXUfZrnRlPzhu"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Flex>
      </Flex>
    </>
  );
};
